<template>
    <div>
        <a href="#" class="text-primary public-review" @click.prevent="showSubmitGuestReviewModal">
            {{ review.public_review }}
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            review: null,
        };
    },
    created() {
        this.review = this.params.data;
    },
    methods: {
        showSubmitGuestReviewModal() {
            this.params.showSubmitGuestReviewModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.public-review {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: underline;
}
</style>
